import { createQueryKeys } from 'utils/react-query-utils';

export const onboardingProgressKeys = createQueryKeys(
  'onboarding-progress',
  (createKey) => ({
    single: (employeeOnboardingProgressId: string) =>
      createKey(employeeOnboardingProgressId),
  }),
);
